<template>
  <div class="top">
    <div class="logo" @click="goto"></div>
    <div class="sh contact" @click="contact">联系我们</div>
<!--    <div class="download_1" @click="download"></div>-->
    <div class="sh" @click="goAbout">关于我们</div>
    <div class="sh" @click="gosh">商户登录</div>
    <div class="dls" @click="godls">代理商登录</div>
  </div>
</template>

<script>
export default {
  name: 'Top',
  components: {},

  data () {
    return {}
  },
  mounted () {},
  methods: {
    goto () {
      this.$router.push('/')
    },
    goAbout () {
      window.open('/aboutus', '_blank')
    },
    gosh () {
      window.open(this.$store.state.sh_url, '_blank')
    },
    godls () {
      window.open(this.$store.state.dls_url, '_blank')
    },
    contact () {
      console.log(this.$store.state.offsetTop)
      window.scrollTo({
        top: this.$store.state.offsetTop,
        left: 0,
        behavior: 'smooth'
      })
    },
    download () {
      const url = this.$store.state.down_url
      const fileUrl = url
      const link = document.createElement('a')
      link.href = fileUrl
      link.setAttribute('download', 'XXXX')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>
<style scoped lang="less">
.top {
  // position: fixed;
  width: 100%;
  // border: 1px solid red;
  background: #020423;
  // background: linear-gradient(to right, #000, #fff);
  height: 78px;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-left: 240px;
  box-sizing: border-box;
  .logo {
    // margin-left: 240px;
    width: 115px;
    height: 41px;
    background: url(~@/assets/images/Logo.png);
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .logo:hover {
    opacity: 0.8;
  }
  .sh {
    margin-left: 24px;
    width: 110px;
    height: 38px;
    line-height: 38px;
    color: #fff;
    cursor: pointer;
    text-align: center;
  }
  .sh:hover {
    color: steelblue;
  }
  .dls {
    margin-left: 10px;
    width: 110px;
    height: 38px;
    cursor: pointer;
    line-height: 38px;
    color: #fff;
    text-align: center;
  }
  .dls:hover {
    color: steelblue;
  }
  .contact{
    margin-left: 1000px;
  }
  .download_1 {
    width: 110px;
    height: 36px;
    background: url(~@/assets/images/d1_2.png);
    cursor: pointer;
    background-size: cover;
  }
  .download_1:hover {
    // background-position: 110px 0;
    background: url(~@/assets/images/d1_1.png);
    background-size: cover;
  }
}
</style>
